import { createContext } from "react";

const ContextoUsuario = createContext();

export default ContextoUsuario;
